import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Calendar = ({ logs }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = new Date(year, month, 1).getDay();

  // Create an object for quick lookup: { 'YYYY-MM-DD': true }
  const readDates = logs.reduce((acc, log) => {
    acc[log.date] = true;
    return acc;
  }, {});

  const prevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const days = [];
  // Padding for first day of week
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push(<div key={`empty-${i}`} style={dayStyle}></div>);
  }

  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    const hasRead = readDates[dateStr];

    days.push(
      <div 
        key={d} 
        style={{
          ...dayStyle,
          backgroundColor: hasRead ? '#4caf50' : '#fff',
          color: hasRead ? 'white' : '#333',
          fontWeight: hasRead ? 'bold' : 'normal',
          border: '1px solid #f0f0f0'
        }}
      >
        {d}
      </div>
    );
  }

  const monthName = currentDate.toLocaleString('default', { month: 'long' });

  return (
    <div style={calendarWrapper}>
      <div style={headerStyle}>
        <button onClick={prevMonth} style={navButtonStyle}><ChevronLeft size={20} /></button>
        <h3 style={{ margin: 0, width: '120px', textAlign: 'center' }}>{monthName} {year}</h3>
        <button onClick={nextMonth} style={navButtonStyle}><ChevronRight size={20} /></button>
      </div>
      
      <div style={weekdayGrid}>
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
          <div key={day} style={weekdayStyle}>{day}</div>
        ))}
      </div>
      <div style={calendarGrid}>
        {days}
      </div>
    </div>
  );
};

const calendarWrapper = {
  backgroundColor: 'white',
  padding: '1.5rem',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  maxWidth: '350px',
  margin: '0 auto'
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '1rem'
};

const navButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
  color: '#666',
  display: 'flex',
  alignItems: 'center'
};

const calendarGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: '4px'
};

const weekdayGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: '4px',
  marginBottom: '8px'
};

const weekdayStyle = {
  textAlign: 'center',
  fontSize: '0.7rem',
  color: '#999',
  fontWeight: 'bold'
};

const dayStyle = {
  aspectRatio: '1 / 1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.8rem',
  borderRadius: '4px'
};

export default Calendar;
